import React from 'react';
import { Text, useWindowDimensions, View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { ImageComp } from '../Image/Image';
import CustomPressable from '../customPressable/customPressable';
import { useCssStyle } from '../../customHook/getCssStyle';
import { setRenderWidgetInfoModal } from '../../Redux/Actions/appConfigAction';
import { getCleanUrl } from '../../utils/Helper';
import CustomModal_Right from '../customModal/customModal_Right';
import { CROSS } from '../../assets';
import RenderHTML from 'react-native-render-html';
import { getStyleForRenderHTML } from '../../js/utility';

const InfoModalWidget_Landscape = () => {
    const {width} = useWindowDimensions();

    const dispatch = useDispatch();
    const getStyles = useCssStyle();
    const { modalData } = useSelector(state => state.appConfigSlice.renderWidgetInfoModal);
    const widgetMetaHtmlId = modalData?.widgetMetaHtmlId;

    const handleClose = () => {
        dispatch(setRenderWidgetInfoModal(false));
    };

    const customGuestRequestHeaderTitleStyle = getStyles(['widgetInfoModalTitle_landscape', `widgetInfoModalTitle_landscape_${widgetMetaHtmlId}`]);
    const customGuestRequestTitleStyle = getStyles(['widgetInfoModalDescription_landscape', `widgetInfoModalDescription_landscape_${widgetMetaHtmlId}`]);

    const { baseStyle: titleHeaderBaseStyle, systemFonts: titleHeaderSystemFonts } = getStyleForRenderHTML(customGuestRequestHeaderTitleStyle);
    const { baseStyle: titleBaseStyle, systemFonts: titleSystemFonts } = getStyleForRenderHTML(customGuestRequestTitleStyle);

    return (
        <CustomModal_Right onRequestClose={handleClose}>
            <View style={getStyles(['widgetInfoModalContainer_landscape', `widgetInfoModalContainer_landscape_${widgetMetaHtmlId}`])} id={`widgetInfoModalContainer_landscape widgetInfoModalContainer_landscape_${widgetMetaHtmlId}`}>
                {/* Close Button */}

                <CustomPressable
                    onPress={handleClose}
                    style={getStyles(['widgetInfoModalCloseBtn_landscape', `widgetInfoModalCloseBtn_landscape_${widgetMetaHtmlId}`])}
                    id={`widgetInfoModalCloseBtn_landscape widgetInfoModalCloseBtn_landscape_${widgetMetaHtmlId}`}
                >
                    <ImageComp source={CROSS} style={getStyles(["widgetInfoModalCloseBtnImg_landscape", `widgetInfoModalCloseBtnImg_landscape_${widgetMetaHtmlId}`])} id={`widgetInfoModalCloseBtnImg_landscape widgetInfoModalCloseBtnImg_landscape_${widgetMetaHtmlId}`} />
                </CustomPressable>

                
                {/* Header Image */}
                {modalData?.widgetHeaderImageUrl && (
                    <View style={getStyles(['widgetInfoModalImageWrapper_landscape', `widgetInfoModalImageWrapper_landscape_${widgetMetaHtmlId}`])} id={`widgetInfoModalImageWrapper_landscape widgetInfoModalImageWrapper_landscape_${widgetMetaHtmlId}`}>
                        <ImageComp
                            source={getCleanUrl(modalData.widgetHeaderImageUrl)}
                            style={getStyles(['widgetInfoModalHeaderImage_landscape', `widgetInfoModalHeaderImage_landscape_${widgetMetaHtmlId}`])}
                            id={`widgetInfoModalHeaderImage_landscape widgetInfoModalHeaderImage_landscape_${widgetMetaHtmlId}`}
                        />
                    </View>
                )}


                {/* Content */}
                <View style={getStyles(['widgetInfoModalContent_landscape', `widgetInfoModalContent_landscape_${widgetMetaHtmlId}`])} id={`widgetInfoModalContent_landscape widgetInfoModalContent_landscape_${widgetMetaHtmlId}`}>
                    {modalData?.contentTitle && (
                        <RenderHTML 
                            contentWidth={width}
                            baseStyle={titleHeaderBaseStyle}
                            source={{html: modalData?.contentTitle}}
                            systemFonts={titleHeaderSystemFonts}
                            id={`widgetInfoModalTitle_landscape`}
                        />
                    )}
                    {modalData?.contentDescription && (
                        <RenderHTML 
                            contentWidth={width}
                            baseStyle={titleBaseStyle}
                            source={{html: modalData?.contentDescription}}
                            systemFonts={titleSystemFonts}
                            id={`widgetInfoModalDescription_landscape`}
                        />
                    )}
                </View>
            </View>
        </CustomModal_Right>
    );
};

export default InfoModalWidget_Landscape;
